import { addLocaleData } from 'react-intl'
import { updateIntl } from 'react-intl-redux'

import locale2 from 'locale2'

import initialState from './data'
import enLocaleData from 'react-intl/locale-data/en'
import ruLocaleData from 'react-intl/locale-data/ru'
addLocaleData([...enLocaleData, ...ruLocaleData])

export const UPDATE_LOCALES = 'UPDATE_LOCALES'

export function initDefaultLocale (store) {
  const defaultLocale = window.localStorage.getItem('locale') || locale2.substring(0, 2)
  store.dispatch(
    updateIntl({
      locale: defaultLocale,
      messages: store.getState().locales[defaultLocale]
    })
  )
}
export default function localesReducer (state = initialState, action) {
  switch (action.type) {
    case UPDATE_LOCALES:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/i18n/index.js